import ContactDirectory from "@/components/ContactDirectory";

export default function SeaFreight({ initialQuery = "" }) {
  return (
    <ContactDirectory
      initialQuery={initialQuery}
      title="Sea Freight"
      subtitle="Sea freight carrier contacts."
      endpoint="/sea-freight"
      prefix="seafreight"
      singular="carrier"
      addLabel="Add carrier"
    />
  );
}
